import {Button,Divider,TextField, Box, FormControl, Grid, Stack, InputAdornment,Dialog, DialogTitle, DialogActions, Backdrop, DialogContent } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { CalendarIcon } from '@mui/x-date-pickers/icons';
import classes from "./ParticipanteClasses.css";
import * as React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Importa el archivo de localización para español

export default function Aval2Precargado({ identidad, nombres, apellidos, nacimiento, profesion, vivienda, barrio, calle, ave, casa, ciudad,
    departamento, estado, referenciadomicilio, fijo, movil, correo, dependencia, ramo, telefonolaboral, barriolaboral, avenidalaboral,
    callelaboral, casalaboral, ciudadlaboral, departamentolaboral, sueldomensual, otrosingresos, sueldoneto, puesto, tiempolaborarA, 
    tiempolaborarM, icono, handleDescargar, openAval2, closeAval2, pdfUrlAval2}) {

    return (
        <>
            <Box>
                <Stack direction="row">
                    <h3 >VI. DATOS PERSONALES - AVAL 2</h3>
                </Stack>

                <Stack direction="row">
                    <Grid container spacing={1}>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval2Identidad" value={identidad} label="Numero de Identidad" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval2Nombres" value={nombres} label="Nombres" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval2Apellidos" value={apellidos} label="Apellidos" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="FechaNacimiento" value={nacimiento} label="Fecha de Nacimiento" variant="outlined"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <CalendarIcon />
                                    </InputAdornment>
                                ),
                                readOnly: true
                            }} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval2Profesion" value={profesion} label="Profesión u Oficio" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                    </Grid>
                </Stack>


                <Stack className={classes.above} direction="row" marginTop={1}>
                    <Grid container>
                        <Stack direction="row" alignItems="center">
                            <label style={{ marginRight: 10 }}><strong>TIPO DE VIVIENDA:</strong></label>
                            <label>{vivienda}</label>
                        </Stack>
                    </Grid>
                </Stack>

                <Stack className={classes.above} direction="row" marginTop={1}>
                    <Grid Container>

                        <Box>
                            <label><strong>Dirección</strong></label>
                            <Box>
                                <Stack direction="row">
                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2Barrio" value={barrio} label="Barrio/Col." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2Ave" value={ave} label="Ave." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2Calle" value={calle} label="Calle." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2Casa" value={casa} label="Casa No." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2Ciudad" value={ciudad} label="Ciudad" variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2Departamento" value={departamento} label="Departamento" variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>
                                </Stack>
                            </Box>
                        </Box>
                        <Box>

                            <FormControl sx={{ m: 1, width: 300 }} >
                                <TextField id="estadocivilAval2" value={estado} label="Estado Civil" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 800 }}>
                                <TextField id="aval2ReferenciaDomicilio" value={referenciadomicilio} label="Referencia Domicilio" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="aval2Fijo" value={fijo} label="Teléfono Fijo" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }} >
                                <TextField id="aval2Movil" value={movil} label="Teléfono Movil" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }} >
                                <TextField id="aval2Correo" value={correo} label="Correo Electrónico" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                        </Box>
                    </Grid>
                </Stack>
            </Box>

            <Box>
                <Stack direction="row">
                    <h3 >VII. INFORMACIÓN LABORAL - AVAL 2</h3>
                </Stack>

                <Stack direction="row">
                    <Grid container>
                        <FormControl sx={{ m: 1, width: 350 }}>
                            <TextField id="aval2Dependencia" value={dependencia} label="Dependencia donde trabaja" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 350 }}>
                            <TextField id="aval2Ramo" value={ramo} label="Ramo" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 350 }}>
                            <TextField id="aval2TelefonoTrabajo" value={telefonolaboral} label="Teléfono" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <Box>
                            <strong>Dirección</strong>
                            <Box>
                                <Stack direction="row">
                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2BarrioTrabajo" value={barriolaboral} label="Barrio/Col." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2AveTrabajo" value={avenidalaboral} label="Ave." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2CalleTrabajo" value={callelaboral} label="Calle" variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2CasaTrabajo" value={casalaboral} label="Casa No." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2CiudadTrabajo" value={ciudadlaboral} label="Ciudad" variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2Departamentotrabajo" value={departamentolaboral} label="Departamento" variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>
                                </Stack>
                            </Box>
                        </Box>

                        <FormControl sx={{ m: 1, width: 200 }}>
                            <TextField id="sueldoMensualAval2" value={sueldomensual} label="Sueldo Mensual" variant="standard" InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        L.
                                    </InputAdornment>
                                ),
                                readOnly: true
                            }}
                            />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="otrosIngresosAval2" value={otrosingresos} label="Otros ingresos (detalle)" variant="standard" InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        L.
                                    </InputAdornment>
                                ),
                                readOnly: true
                            }}
                            />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 200 }}>
                            <TextField id="sueldoNetoAval2" value={sueldoneto} label="Sueldo Neto" variant="standard" InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        L.
                                    </InputAdornment>
                                ),
                                readOnly: true
                            }}
                            />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval2Puesto" value={puesto} label="Puesto" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <Box>
                            <Box>
                                <label><strong>Tiempo De Laborar</strong></label>
                            </Box>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="aval2Years" value={tiempolaborarA} label="Años" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>

                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="aval2Meses" label="Meses" value={tiempolaborarM} variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                        </Box>
                    </Grid>

                </Stack>
            </Box>
            <Box marginTop={3}>
                <h3>IDENTIDAD DEL AVAL 2 EN FORMATO PDF</h3>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box
                        style={{
                            padding: '50px',
                            width: '700px',
                            textAlign: 'center',
                            borderColor: 'gray',
                            borderRadius: 5,
                            borderWidth: 5,
                            borderStyle: 'dashed',
                        }}
                    >
                        <img src={icono} alt="Download PDF Icon" style={{ width: 75, height: 77, color: 'gray' }} />
                        <br />
                        <Button
                            variant="contained"
                            onClick={handleDescargar}
                            color="primary"
                            style={{ marginTop: '10px', backgroundColor: '#AD8401' }}
                        >
                            Ver Archivo PDF
                        </Button>
                        <p>Haz clic en el botón para visualizar la identidad del aval 2 en PDF</p>
                        <Backdrop open={openAval2} onClick={closeAval2} style={{ zIndex: 1 }}>
                            <Dialog
                                open={openAval2}
                                onClose={closeAval2}
                                maxWidth="md"
                                fullWidth
                            >
                                <DialogTitle textAlign={'center'}>Identidad Del Aval 2</DialogTitle>
                                <DialogContent>
                                    <iframe
                                        src={pdfUrlAval2}
                                        width="100%"
                                        height="450px"
                                        style={{ border: 'none' }}
                                    />
                                </DialogContent>
                            </Dialog>
                        </Backdrop>
                    </Box>
                </Box>
            </Box>
            <Divider style={{ marginTop: 5 }} />
        </>
    );
}
